export enum PaymentTypeEnum {
    VIRTUAL = 'VIRTUAL', // Vendas geradas com LINK de pagamento. Ex. Link do pago livre.
    PHYSICAL = 'PHYSICAL', // Vendas geradas pela maquina fisica lá na loja. Ex. Maquininha de cartao da STONE.
}

export enum PaymentTypeLabelEnum {
    VIRTUAL = 'Link de Pagamento',
    PHYSICAL = 'Maquininha de Cartão',
}
